
export const BASE_URL_API = 'https://devapisbot.ceibagreen.com/api/';  //dev url
export const IMG_URL = 'https://devapisbot.ceibagreen.com/';   //dev image url

// export const BASE_URL_API = 'https://singada1319api.ceibagreen.com/api/';  
// export const IMG_URL = 'https://singada1319api.ceibagreen.com/';  
